import React from "react"
import Fade from "react-reveal/Fade"
import group_image from "../images/dub.jpeg"
import data from "../yourdata"

// import scss for headr
import "../styles/Header.scss"
import "../styles/include-media.scss"

const Header = () => {
  return (
    <div className="section">
            <div className="container">
                <Fade top>
                <h1>Data Driven Optimal Control of Two Point Boundary Problems </h1>
                </Fade>
                <div className="publications">
                    <div classsName="row">
                        <div className="publication">
                        <table class = 'noBorder'>
                                <tbody class='noBorder'>
                                    <tr class='noBorder'>
                                        <td class='noBorderimg'>
                                            <div >
                                                <img className="image-wrapper" src={data.acc} alt="Vasanth" />
                                            </div>
                                        </td>
                                        <td class='noBorder'>
                                            <div className="publication-title">

                                            </div>
                                        </td>
                                        <td class='noBorderdetails'>

                                            <div>
                                              <p className="bottom-three">Papers</p>
                                              <span>
                                                <a className="link-three" href="https://arxiv.org/pdf/2104.09652.pdf">2022 ACC Paper</a>
                                              </span>
                                              <br/>
                                              <p className="bottom-three">Members</p>
                                              <span>
                                                <a className="link-three" href="shorturl.at/bpsW7">Vasanth Reddy Baddam</a>, <a className="link-three" href="http://boker.ece.vt.edu/">Almuatazbellah (Muataz) Boker</a>, <a className="link-three" href="https://people.cs.vt.edu/hdardiry/">Hoda Eldardiry</a>
                                              </span>
                                            </div>
                                            
                                            <div>
                                                
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <p className="header-p">
                                Introduction
                            </p>
                            <br/>
                            <p className="header-l">
                            The main objective of this work is to learn the controller
for the finite horizon time varying systems when the boundary
conditions are given. Initially, we focus on the linear time-varying system and then further extending it to the nonlinear systems. We mainly 
focus on the optimalaity, stability and robustness of the controller.In summary, the key contributions 
of this work are twofold: 
<ul className="header-q"><li className="header-l">1.We provide a solution for the two-boundary
optimal control problem for dynamical systems that
does not require knowledge of system models.</li><li className="header-l">
2.We introduce a reinforcement learning framework that
is based on an insight from the physical dynamics. This
framework is simple to implement and results in a suboptimal
solution, which converges to the optimal one as the control
time interval gets large</li></ul>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Header
